<template>
    <div class="container">
        <div class="bg-white pt-pb-16 pl-pr-16">
            <p class="page-policy">
            <h1>Privacy Policy</h1>
            <p>Update: Jan 30, 2020.</p>
            <p>Welcome to Mrdict!</p>
            <p>Thanks for using our products and services (“Services”).</p>
            <p>By using our Services, you are agreeing to these Privacy Policy terms. Please read them
                carefully.</p>
            <p>We provide a free service and, as such, we provide no warranty or guarantee of service or
                uptime. Any automated use of our service is strictly forbidden without express permission from
                us. Persons found to be using automation will be immediately and permanently banned. Mrdict
                reserves the right to make changes and improvements to these Policies at any time and without
                notice. We public these Policies at https://mrdict.com/privacy.html.</p>
            <p>By using our Services, you acknowledge that you have read, understand and agree to these
                terms/policies and do so at your own risk. These polices control the relationship between
                Mrdict and you. They do not create any third party beneficiary rights.</p>
            <p>You must follow any policies made available to you within the Services, following these
                details:</p>
            <h2>1. Collect & Store & Use of Information</h2>
            <p>We collect, store and use anonymous information as below:</p>
            <p>- We identify you as anonymous id, called Client ID, it's a random ID generated when you
                visit our official website (mrdict.com) or install this extension. We store this Client ID and
                use it to recognize you each time you use this extension or visit our website.</p>
            <p>- Anonymous ID and IP: We identify you by Anonymous id: Client ID (a random id which is
                generated first time you use our Service) and IP. We store and use them prevent fraud install
                and spam traffic.</p>
            <p>- We collect browser’s top site list (a list of website name, not browsing history), which
                are provided by your browser, to to create and arrange shortcut to your favorite websites
                Mrdict’s New Tab UI.</p>
            <h2>2. Information Security</h2>
            <p>The information we collect is for the purpose improve the Service ONLY. We don't transfer
                and/or share to any third parties in any circumstance, except requested by law or competent
                authority.</p>
            <p>We might transfer your information from server to server when we change infrastructure
                provider, in this case we use secured method (like https, ftps, ssh, …) to transfer your
                information.</p>
            <p>We delete your information in case we acknowledge your request to do that.</p>
            <h2>3. Group/Organization policy</h2>
            <p>If your group/organization install our Service for you with some additional policies, those
                additional policy is belong to your group/organization you belong to, we don't take
                responsible for those additional policies except the case we announce them on this Policy. You
                might ask us to delete or remove our Service anytime you want.</p>
            <h2>4. About these policies</h2>
            <p>We may modify these policies or any additional policy that apply to a Service to, for
                example, reflect changes to the law or changes to our Services. You should look at the terms
                regularly. We’ll post notice of modifications to these policies on this page. We’ll post
                notice of modified additional policy in the applicable Service. Changes will not apply
                retroactively and will become effective no sooner than fourteen days after they are posted.
                However, changes addressing new functions for a Service or changes made for legal reasons will
                be effective immediately. If you do not agree to the modified policies, you could discontinue
                your use of that Service.</p>
            <p>If you do not comply with these policies, and we don’t take action right away, this doesn’t
                mean that we are giving up any rights that we may have (such as taking action in the
                future).</p>
            <p>For information about how to contact Mrdict, please visit our contact at home page
                https://mrdict.com.</p>
            <p>For information about how to contact Mrdict, please visit our contact at home page: <a
                    href="https://mrdict.com">https://mrdict.com</a></p>
        </div>
    </div>
</template>
<script>
  export default {}
</script>
<style lang="scss" scoped>

</style>
